import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ModelManageMenu/MenuSection/ModelContent.tsx";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { Button, Divider, styled } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { Home as HomeIcon } from '@gmini/ui-kit';
import { useHover } from '@gmini/utils';
import * as api from '@gmini/sm-api-sdk';
import { NumCircle } from "../../../components";
import { VersionButton } from "../../SelectDependencies/ModelsTree/VersionButton/VersionButton";
import { UpdateDialog } from "../../Migration/UpdateDialog";
import { useReadonlyMode } from "../../../hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var ModelContent = /*#__PURE__*/React.memo(function (_ref) {
  var modelItem = _ref.modelItem,
      divider = _ref.divider,
      currentEntityData = _ref.currentEntityData;
  var author = modelItem.author,
      versionName = modelItem.versionName,
      depIndex = modelItem.depIndex,
      status = modelItem.status,
      title = modelItem.title,
      baseClassifierId = modelItem.baseClassifierId,
      uploadDate = modelItem.uploadDate,
      urn = modelItem.urn,
      versionId = modelItem.versionId,
      projectUrn = modelItem.projectUrn;

  var _useHover = useHover(),
      hover = _useHover.hover,
      onMouseLeave = _useHover.onMouseLeave,
      onMouseOver = _useHover.onMouseOver;

  var classes = useStyles();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      updateDialogOpen = _React$useState2[0],
      setUpdateDialogOpen = _React$useState2[1];

  var _useReadonlyMode = useReadonlyMode(),
      readonlyMode = _useReadonlyMode.readonlyMode;

  var onUpdateDialogClose = React.useCallback(function () {
    setUpdateDialogOpen(false);
  }, []);
  var onMove = React.useCallback(function () {
    setUpdateDialogOpen(true);
  }, []);
  var onLoad = React.useCallback(function () {
    api.BimFile.Import.defaultContext.submit({
      bimFileUrn: urn,
      bimFileVersion: versionId,
      projectUrn: projectUrn
    });
  }, [urn, projectUrn, versionId]);
  var actionBtnJSX = React.useMemo(function () {
    switch (status) {
      case 'ImportCompleted':
        return /*#__PURE__*/_jsx(ActionButton, {
          "data-test-id": "updateVersion",
          onClick: onMove,
          children: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438"
        });

      case 'NotImported':
        return /*#__PURE__*/_jsx(ActionButton, {
          onClick: onLoad,
          children: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C"
        });

      case 'ImportError':
        return /*#__PURE__*/_jsx(ActionButton, {
          onClick: onLoad,
          children: "\u0420\u0435\u0441\u0442\u0430\u0440\u0442"
        });
    }
  }, [status, onMove, onLoad]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [updateDialogOpen && baseClassifierId &&
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-undef
    _jsx(UpdateDialog, {
      name: title,
      baseClassifierId: baseClassifierId,
      currentEntityData: currentEntityData,
      onClose: onUpdateDialogClose,
      disabled: readonlyMode.enabled
    }), /*#__PURE__*/_jsxs("div", {
      className: classes.root,
      onMouseLeave: onMouseLeave,
      onMouseOver: onMouseOver,
      children: [/*#__PURE__*/_jsx("div", {
        className: classes.iconWrap,
        children: /*#__PURE__*/_jsx(HomeIcon, {})
      }), /*#__PURE__*/_jsx("span", {
        className: classes.titleText,
        children: title
      }), /*#__PURE__*/_jsx(NumCircle, {
        children: depIndex + 1
      }), !readonlyMode.enabled && /*#__PURE__*/_jsx("div", {
        className: classes.actions,
        children: hover && actionBtnJSX ? actionBtnJSX : /*#__PURE__*/_jsx(VersionButton, {
          versionName: versionName,
          status: status,
          author: author,
          showVersion: true,
          uploadDate: uploadDate
        })
      })]
    }), divider && /*#__PURE__*/_jsx(Divider, {})]
  });
});
ModelContent.displayName = 'ModelContent';
var useStyles = makeStyles(function () {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      paddingTop: '10px',
      paddingBottom: '10px'
    },
    actions: {
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'flex-end',
      minWidth: '80px'
    },
    iconWrap: {
      marginRight: '8px',
      display: 'flex',
      alignItems: 'center'
    },
    titleText: {
      marginRight: '6px'
    }
  };
});
var ActionButton = styled(Button)({
  backgroundColor: '#00003D',
  color: '#fff',
  fontSize: '10px',
  textTransform: 'none',
  paddingTop: '2px',
  paddingBottom: '2px',
  paddingLeft: '7px',
  paddingRight: '7px',
  '&:hover': {
    backgroundColor: '#00003D',
    color: '#fff'
  }
});